/**
 * use-scroll-collapse.ts — Đã cuộn danh sách xuống khỏi đầu hay chưa (điện thoại: thu gọn phần tên/kênh ở đầu
 * Hộp thư khi cuộn, ghim phần bộ lọc — xem mobile-inbox-header.tsx).
 *
 * Gắn vào khung bao ngoài vùng cuộn (Radix ScrollArea: tìm `[data-radix-scroll-area-viewport]`, cùng cách
 * use-pull-to-refresh.ts đọc `scrollTop`). `threshold` nhỏ để chỉ cần nhích ngón tay một chút là thu gọn ngay,
 * tránh header nhấp nháy quanh mốc 0.
 */
import { useEffect, useState, type RefObject } from 'react'

export function useScrollCollapse(ref: RefObject<HTMLElement | null>, enabled: boolean, threshold = 8): boolean {
  const [collapsed, setCollapsed] = useState(false)

  useEffect(() => {
    if (!enabled) { setCollapsed(false); return }
    const el = ref.current
    if (!el) return
    const viewport = el.querySelector<HTMLElement>('[data-radix-scroll-area-viewport]')
    if (!viewport) return

    const onScroll = () => setCollapsed(viewport.scrollTop > threshold)
    onScroll() // danh sách đã có sẵn vị trí cuộn (vd quay lại từ hội thoại khác) — không đợi lần cuộn kế tiếp mới cập nhật
    viewport.addEventListener('scroll', onScroll, { passive: true })
    return () => viewport.removeEventListener('scroll', onScroll)
  }, [ref, enabled, threshold])

  return collapsed
}
